//
// GENERATED by KVision
//
package pl.finn.forms

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule

actual class FormsService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : IFormsService, KVRemoteAgent<FormsService>(FormsServiceManager, serializersModules, requestFilter) {
    override suspend fun anuluj(token: String) = call(IFormsService::anuluj, token)
}
